import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { Link, useParams, useNavigate } from "react-router-dom";

import SettingsPage from '../partials/SettingsPage';
import LoadingSpinner from '../partials/LoadingSpinner';
import PageHeader from '../partials/PageHeader';
import ToteGrid from '../partials/ToteGrid';

import { Button, Text, Small, Panel, H3, H4, Dropdown, Input, Tabs, Datepicker, Textarea, Box, Select } from '@bigcommerce/big-design';
import { AddIcon, ArrowDropDownIcon, AddCircleOutlineIcon, StoreIcon } from '@bigcommerce/big-design-icons';

import { cartLayoutFind, cartLayoutUpdate } from '../../redux/actions/cartLayouts';

const UpdateCartLayoutForm = ({ payload, cartLayouts, newCartLayout, loadCartLayout, updateCartLayout }) => {
  const { id } = useParams();
  let navigate = useNavigate();

  const [submitted, setSubmitted] = useState(false);
  const [label, setLabel] = useState(null);
  const [rows, setRows] = useState(1);
  const [columns, setColumns] = useState(1);
  const [toteLabels, setToteLabels] = useState([[undefined]]); // a 2D array rowsxcolumns with given names per tote

  useEffect(() => {
    console.log(id);
    loadCartLayout(payload, id);
  }, []);

  useEffect(() => {
    if(newCartLayout) { navigate(-1) };
  }, [newCartLayout]);

  useEffect(() => {
    if(cartLayouts.activeCartLayout) {
      setLabel(cartLayouts.activeCartLayout.label);
      setRows(cartLayouts.activeCartLayout.rows);
      setColumns(cartLayouts.activeCartLayout.columns);
      setToteLabels(cartLayouts.activeCartLayout.tote_labels);
    }
  }, [cartLayouts]);

  const setRowCount = (e) => {
    let rowCount = parseInt(e.target.value);
    let growRows = rowCount > rows;

    setRows(rowCount);

    // Resize the tote labels array here
    toteLabels.length = rowCount;

    if(growRows) {
      toteLabels.fill(Array(columns), rows, rowCount);
    }

    console.log(toteLabels);
  }

  const setColumnCount = (e) => {
    let columnCount = parseInt(e.target.value);
    let growColumns = columnCount > columns;

    setColumns(columnCount);

    // Resize the tote labels array here
    toteLabels.forEach(column => {
      column.length = columnCount;

      if(growColumns) {
        column.fill(undefined, columns, columnCount);
      }
    })

    console.log(toteLabels);
  }

  const setLabelText = (rowIndex, columnIndex, e) => {
    let value = e.target.value;

    console.log(value);

    let updatedLabels = structuredClone(toteLabels);

    updatedLabels[rowIndex][columnIndex] = value;

    setToteLabels(updatedLabels);
  }

  const submitCartLayout = () => {
    // setSubmitted(true);
    updateCartLayout(payload, id, label, rows, columns, toteLabels);
  }

  const description = () => {
    return(
      <>
        <Small>Have questions or need some help? Contact us at <a href="mailto:support@athousandapps.com">support@athousandapps.com</a></Small>
      </>
    )
  }

  if(!cartLayouts.activeCartLayout) {
    return (
      <>
        <PageHeader stripeBackground='#c66628' helpLink="" />
        <SettingsPage title="Update Cart Layout" description={description()}>
          <Panel>
            <H3>Update Cart Layout</H3>

            <LoadingSpinner size="xxSmall" statusText="Loading cart layout" />

          </Panel>
        </SettingsPage>
      </>
    )
  }


  return(
    <>
      <PageHeader stripeBackground='#c66628' helpLink="" />
      <SettingsPage title="Update Cart Layout" description={description()}>
        <Panel>
          <H3>Update Cart Layout</H3>

          <Input 
            required 
            label="Cart Layout Name"
            placeholder="Cart Layout Name"
            id="label" 
            type="text" 
            value={label} 
            onChange={(e) => setLabel(e.target.value)} 
          />

          <Input 
            required 
            label="Rows"
            placeholder="Rows"
            id="rows" 
            type="number" 
            min="1"
            value={rows} 
            onChange={(e) => setRowCount(e)} 
          />

          <Input 
            required 
            label="Columns"
            placeholder="Columns"
            id="columns" 
            type="number" 
            min="1"
            value={columns} 
            onChange={(e) => setColumnCount(e)} 
          />

        </Panel>

        <ToteGrid
          label="Tote Labels"
          description="Set custom tote labels. These values will be shown as descriptors in cart layout sections of the app when picking and packing."
          rows={rows}
          columns={columns}
          content={toteLabels}
          setContentText={setLabelText}
          allowUpdates={true}
        />

        <Panel>
          <Button 
            iconLeft={<AddIcon />}
            disabled={ submitted }
            onClick={() => submitCartLayout() }
            isLoading={submitted}
          >
            Update Cart Layout
          </Button>
        </Panel>

      </SettingsPage>
    </>
  )
}

const mapStateToProps = state => ({
  cartLayouts: state.cartLayouts,
  newCartLayout: state.cartLayouts.newCartLayout,
});

const mapDispatchToProps = (dispatch) => ({
  loadCartLayout: (payload, id) => dispatch(cartLayoutFind(payload, id)),
  updateCartLayout: (payload, id, label, rows, columns, toteLabels) => dispatch(cartLayoutUpdate(payload, id, label, rows, columns, toteLabels)),
});

export default connect(mapStateToProps, mapDispatchToProps)(UpdateCartLayoutForm);